<template>
  <component :is="layout">
    <Loading v-if="loading" />
    <AuthModal :openAuthModal.sync="openAuthModal" />
    <SuccessRegistration />
    <StatusModal />
    <WaitTransaction />
    <slot />
  </component>
</template>

<script>
import Loading from '../components/Loading.vue'
import StatusModal from '../components/modal/StatusModal.vue'
import { mapGetters } from 'vuex'
import AuthModal from '../components/modal/AuthModal.vue'
import SuccessRegistration from '../components/modal/SuccessRegistration.vue'
import WaitTransaction from '../components/modal/WaitTransaction.vue'
export default {
  components: { SuccessRegistration, StatusModal, Loading, AuthModal, WaitTransaction },
  name: 'AppLayout',

  data() {
    return {
      defaultLayout: 'DefaultLayout'
    }
  },

  computed: {
    ...mapGetters(['loading']),
    layout() {
      const layout = this.$route.meta.layout || this.defaultLayout
      return () => import(`@/layouts/${layout}.vue`)
    },
    openAuthModal: {
      get() {
        return this.$store.getters.openAuthModal
      },
      set(val) {
        this.$store.dispatch('openAuthModal', val)
      }
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/layouts/Layout.vue